<template>
  <div v-if="this.show" class="mb-eseal-wrap">
    <div class="seal-bg">
      <div class="header">
        <div class="left" @click="cancel"></div>
        <div class="middle">意愿认证</div>
      </div>
      <div v-if="!isFinish">
        <div v-if="type == 'code'">
          <div class="type-text">短信认证</div>
          <div class="account">
            <div class="point">*</div>
            <div class="right-input">
              <div class="account-text">账号</div>
              <input
                class="number-input"
                type="number"
                v-model="phone"
                disabled="true"
              />
            </div>
          </div>
          <div class="account">
            <div class="point">*</div>
            <div class="right-input">
              <div class="password-text">短信验证码</div>
              <input
                class="number-input"
                placeholder="请输入您的签署密码"
                v-model="code"
              />
              <div class="errtip" v-if="noCode">请输入短信验证码</div>
            </div>
            <div class="code-button" @click="sendMessage">
              {{ text }}{{ count > 0 ? "(" + count + ")" : "" }}
            </div>
          </div>
        </div>
        <div v-if="type == 'password'">
          <div class="type-text">密码认证</div>
<!--          <div class="account">
            <div class="point">*</div>
            <div class="right-input">
              <div class="account-text">账号</div>
              <input
                class="number-input"
                type="number"
                v-model="phone"
                disabled="true"
              />
            </div>
          </div> -->
          <div class="account">
            <div class="point">*</div>
            <div class="right-input">
              <div class="password-text">签署密码</div>
              <input
                class="number-input"
                placeholder="请输入您的签署密码"
                type="password"
                v-model="password"
              />
              <div class="errtip" v-if="noPassword">请输入密码</div>
            </div>
          </div>
        </div>

        <button class="add" @click="reComfirm">
          提交
        </button>
        <div class="foot">
          <div class="foot-contain">
            <div class="icon"></div>
            本次认证服务由e签宝提供
          </div>
          <div class="other" @click="chooseType">
            <div class="safe"></div>
            其他方式
          </div>
        </div>
      </div>
      <div v-if="isFinish">
        <div v-if="isSuccess">
          <div class="check-icon_succ"></div>
          <div class="result">意愿认证已完成</div>
          <div class="back" @click="cancel">
            返回首页{{ number > 0 ? "(" + number + ")" : "" }}
          </div>
        </div>
        <div v-else>
          <div class="check-icon"></div>
          <div class="result">意愿认证失败</div>
          <div class="errmes">认证失败原因</div>
          <div class="errmes">1.{{ errMes }}</div>
          <div class="reComfirm-btn1" @click="cancel">重新认证</div>
        </div>
      </div>
    </div>
    <div class="modal" v-if="showLoading">
      <div class="load-box">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="40px"
          height="40px"
          viewBox="0 0 50 50"
          style="enable-background: new 0 0 50 50;"
          xml:space="preserve"
        >
          <path
            fill="#409eff"
            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
            transform="rotate(275.098 25 25)"
          >
            <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.6s"
              repeatCount="indefinite"
            ></animateTransform>
          </path>
        </svg>
      </div>
    </div>
    <div
      class="modal"
      v-if="isShowType"
      @mousewheel.prevent
      @click.self="closeType"
    >
      <div class="choose-pop" :style="{ height: isShowType ? 'auto' : '0' }">
        <div class="title">请选择认证方式</div>
        <div
          class="pop-item"
          v-for="(item, index) in typeList"
          :key="index"
          @click="changeType(item)"
        >
          <div>
            <span :class="item.type == type ? 'choosed' : ''">{{
              item.title
            }}</span>
            <span class="recomand" v-if="item.isRecomand">推荐</span>
          </div>
          <div class="right">
            {{ item.message
            }}<span class="ok"> {{ item.type == type ? "✔" : "" }}</span>
          </div>
        </div>
        <div class="divi"></div>
        <div class="pop-item pop-cancel" @click="closeType">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      showLoading: false,
      type: "code",
      phone: handler.userInfo.mobile,
      password: "", //密码
      code: "", //验证码
      isShowType: false,
      noCode: false,
      noPassword: false,
      isFinish: false, // 意愿认证是否完成
      isSuccess: false, //意愿认证是否成功
      number: 0,
      typeList: [
        {
          type: "code",
          isRecomand: true,
          title: "短信认证",
          message: "需要有大陆手机号",
        },
        {
          type: "password",
          isRecomand: false,
          title: "密码认证",
          message: "需优先设置签署密码",
        },
      ],
      text: "获取验证码",
      count: 0,
      kaptchaId: "", //验证码返回
      loginId: "", //意愿认证成功返回
      recordId: "",
    }
  },
  computed: {},
  methods: {
    changeType: function (item) {
      this.type = item.type
      this.isShowType = false
    },
    cancel: function () {
      this.code = ""
      this.password = ""
      this.isFinish = false
      this.$parent.isShowPurpose = false
    },
    chooseType: function () {
      this.isShowType = true
    },
    closeType: function () {
      this.isShowType = false
    },
    reComfirm: function () {
      var that = this
      if (this.type === "code") {
        if (!this.code) {
          this.noCode = true
          setTimeout(function () {
            that.noCode = false
          }, 3000)
          return
        }
        this.reComfirmByPhone()
      } else if (this.type === "password") {
        if (!this.password) {
          this.noPassword = true
          setTimeout(function () {
            that.noPassword = false
          }, 3000)
          return
        }
        this.reComfirmByPassword()
      }
    },
    sendMessage: function () {
      var that = this
      if (this.count > 0) return
      this.uuid = ""
      this.reGetCode()
      this.count = 60
      this.text = "重新获取"
      var timer = setInterval(function () {
        if (that.count > 0) {
          that.count--
        } else {
          clearInterval(timer)
        }
      }, 1000)
    },
    //发送验证码
    reGetCode: function () {
      var that = this
      $.ajax({
        url: handler.severUrl + "/V1/authentication/sendSMSKaptcha",
        type: "post",
        headers: {
          "Content-Type": "application/json;charset=utf8",
          "x-timevale-project-id": "1000000",
          "x-timevale-signature":
            "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
        },
        data: JSON.stringify({
          accountId: handler.userInfo.id,
          accountType: 1,
          mobile: handler.userInfo.mobile,
          projectId: 1000000,
        }),
        success: function (data) {
          that.kaptchaId = data.data.kaptchaId
        },
        error: function (data) {
          console.log("error")
        },
      })
    },
    //密码验证
    reComfirmByPassword: function () {
      this.showLoading = true
      var that = this
      $.ajax({
        url: handler.severUrl + "/V1/authentication/validateAuth",
        type: "post",
        headers: {
          "Content-Type": "application/json;charset=utf8",
          "x-timevale-project-id": "1000000",
          "x-timevale-signature":
            "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
        },
        data: JSON.stringify({
          accountUniqueId: handler.userInfo.uniqueId,
          authId: "bde97a46-c538-47c1-9246-a7b131bb547f",
          authInfo: {
            authValue: "",
            fileKey: "",
            fileMD5: "",
            fingerValue: "",
            identityCode: "",
            kaptchaId: "",
            mobile: handler.userInfo.mobile,
            password: CryptoJS.MD5(that.password + "").toString(
              CryptoJS.enc.Hex
            ),
            serialNo: "",
            type: 0,
            text: "获取验证码",
          },
        }),
        success: function (data) {
          that.isFinish = true
          that.showLoading = false
          if (data.errCode == 0) {
            that.loginId = data.data.loginId
            that.recordId = data.data.recordId
            that.$parent.authRecordId = data.data.recordId
            that.isSuccess = true
            that.number = 3
            var timer = setInterval(function () {
              if (that.number > 0) {
                that.number--
              } else {
                that.cancel()
                clearInterval(timer)
              }
            }, 1000)
            that.$emit("check-succ") //父组件将所有签章改为可验签，并提交签署
          } else {
            that.errMes = data.msg
            that.isSuccess = false
          }
        },
        error: function (data) {
          console.log("error")
        },
      })
    },
    //手机验证
    reComfirmByPhone: function () {
      this.showLoading = true
      var that = this
      $.ajax({
        url: handler.severUrl + "/V1/authentication/validateAuthWithCode",
        type: "post",
        headers: {
          "Content-Type": "application/json;charset=utf8",
          "x-timevale-project-id": "1000000",
          "x-timevale-signature":
            "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
        },
        data: JSON.stringify({
          accountUniqueId: "zyh",
          authId: "4e2e7a34-86f9-4b37-b32d-dfe0309b6376", //写死
          authInfo: {
            authValue: "",
            fileKey: "",
            fileMD5: "",
            fingerValue: "",
            identityCode: that.code, //短信验证码
            kaptchaId: that.kaptchaId, //发短信返回的值
            mobile: handler.userInfo.mobile, //手机号
            password: "",
            serialNo: "",
            type: 0,
            errMes: "",
          },
          code: "",
          loginFromBackend: 0,
          recordId: "",
        }),
        success: function (data) {
          that.isFinish = true
          that.showLoading = false
          if (data.errCode == 0) {
            that.loginId = data.data.loginId
            that.recordId = data.data.recordId
            that.$parent.authRecordId = data.data.recordId
            that.isSuccess = true
            that.number = 3
            var timer = setInterval(function () {
              if (that.number > 0) {
                that.number--
              } else {
                that.cancel()
                clearInterval(timer)
              }
            }, 1000)
            that.$emit("check-succ")
          } else {
            that.errMes = data.msg
            that.isSuccess = false
          }
        },
        error: function (data) {
          console.log("error")
        },
      })
    },
  },
}
</script>
<style scoped>
.seal-bg {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 998;
  background-color: #ffffff;
}
.header {
  display: flex;
  height: 20px;
  margin-top: 10px;
}
.left {
  width: 20px;
  height: 20px;
  background: url("./icon/left.png") no-repeat center center;
  background-size: 100% 100%;
  margin-left: 10px;
}
.middle {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #333333;
  text-align: center;
  width: calc(100% - 20px);
  margin-right: 40px;
}
.type-text {
  width: 80px;
  margin: 0 auto;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #1a1a1a;
  margin-top: 40px;
}
.account {
  position: relative;
  display: flex;
  margin-top: 20px;
  padding: 0 10px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
input {
  width: 363px;
  height: 32px;
  background: #ffffff;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #999999;
  outline: none;
  border-radius: 3px;
  border: none;
  border-bottom: solid 1px #cccccc;
}
.point {
  color: #e63740;
}
.account-text {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #cccccc;
}
.number-input {
  width: 100%;
  margin-top: 10px;
}
.password-text {
  color: #000000;
}
.add {
  background: #0975e0;
  width: 334px;
  height: 44px;
  border-radius: 4px;
  color: #ffffff;
  border: none;
  margin-top: 30px;
  margin-left: calc(50% - 167px);
}
.foot {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #f7f8fa;
  height: 32px;
}
.foot-contain {
  width: 210px;
  margin: 0 auto;
  line-height: 32px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #999999;
}
.icon {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  top: 4px;

  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAYAAAA+stv/AAABEklEQVRYR+1Xu4qEMBQ9qcRHozaCooKFIH6Bv61fIFjYW1mIlSCIu6iFFurgFIEtdtmsGWaLpLtw783hPAIhePMhaZqe78JACPkQAAQD/5MBVVURBAENxzAM6LqO1rZtwzRNpvDUdY11Xb/MfJsCwzCQJAltbtsWVVXROo5j+L7PBCDPc0zTJADwYUCWZUiSxCTBRf9xHHwAMN38Q/OfTSgARFEE13WZiCiKAvM88/GAeAfCMITjOEwSlGWJZVn4SMB0s4jhKxjQNA3Xc8xyxnHEvu98PCBi+HIGFEWB53lUr0u/vu9pbVkWdF1nsQCapsG2bb/zANPmG83iZyQYeDKQZdl4w0e3Rs/z/CS3NnAYfgDQ81BfvE/PkgAAAABJRU5ErkJggg==");
}
.other {
  position: fixed;
  display: flex;
  width: 131px;
  height: 40px;
  right: -2px;
  top: 70%;
  border: solid 1px #ececec;
  border-radius: 20px 0 0 20px;
  color: #0975e0;
  line-height: 40px;
}
.safe {
  width: 20px;
  height: 20px;
  background: url("./icon/safe.png") no-repeat center center;
  background-size: 100% 100%;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
}
.choose-pop {
  box-sizing: border-box;
  border-radius: 3% 3% 0 0;
  position: fixed;

  width: 100vw;
  left: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 1000;
  background: #ffffff;
  transition: height 0.5s;
}
.right-input {
  width: 100%;
}
.errtip {
  color: #e63740;
  font-size: 14px;
}
.title {
  font-family: PingFangSC-Regular;
  text-align: center;
  color: #999999;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  border-bottom: solid 1px #999999;
}
.pop-item {
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  border-bottom: solid 1px #999999;
  padding: 0 5%;
}
.right {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
}
.ok {
  margin-left: 16px;
  color: #0975e0;
}
.recomand {
  font-size: 12px;
  border-radius: 0 3px 0 3px;
  color: #ffffff;
  background: #0975e0;
}
.divi {
  height: 8px;
  background: #e5e5e5;
}
.pop-cancel {
  justify-content: space-around;
}
.choosed {
  color: #0975e0;
}
.code-button {
  right: 10px;
  position: absolute;
  top: 32px;
  position: absolute;
  color: #0082ff;
}
.check-icon_succ {
  margin: 0 auto;
  margin-top: 80px;
  width: 60px;
  height: 60px;
  background: url("./icon/success.png") no-repeat center center;
  background-size: 100% 100%;
}
.check-icon {
  margin: 0 auto;
  margin-top: 80px;
  width: 60px;
  height: 60px;
  background: url("./icon/rejected.svg") no-repeat center center;
  background-size: 100% 100%;
  height: 60px\9 !important;
  width: 60px\9 !important;
}
.result {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  margin-top: 20px;
}
.reComfirm-btn1 {
  background: #0975e0;
  border-radius: 4px;
  color: #ffffff;
  width: 339px;
  height: 44px;
  text-align: center;
  margin: 0 auto;
  font-size: 18px;
  margin-top: 20px;
  line-height: 44px;
}
.errmes {
  color: #999999;
  font-size: 14px;
  text-align: center;
  margin-top: 5px;
}
.back {
  background: rgb(9, 117, 224);
  margin-top: 20px;
  border-radius: 4px;
  color: rgb(255, 255, 255);
  width: 339px;
  height: 44px;
  text-align: center;
  margin: 20px auto 0px;
  font-size: 18px;
  line-height: 44px;
}
.load-box {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
